import { A } from "@solidjs/router"
import { For, Show } from "solid-js"
import { useLanguage } from "@/context/language"
import { collectionPath } from "@/cowork/scope-url"
import { workspaceHref } from "@/cowork/workspace-route"
import { formatDate } from "@/utils/date"
import "./setup-navigation.css"

export function SetupBreadcrumbs(props: { items: { label: string; href?: string }[] }) {
  const language = useLanguage()
  return <nav class="setup-breadcrumbs" aria-label={language.t("cowork.enterprise.scope.navigation")}>
    <ol><For each={props.items}>{(item) => <li>
      <Show when={item.href} fallback={<span aria-current="page">{item.label}</span>}>
        <A href={workspaceHref(item.href!)}>{item.label}</A>
      </Show>
    </li>}</For></ol>
  </nav>
}

/** Working context is labeled separately from the page's navigation hierarchy. */
export function AccountingScopeSummary(props: {
  company: { id: string; name: string }
  project?: { id: string; name: string }
  period?: { name: string }
}) {
  const language = useLanguage()
  return <dl class="setup-scope-summary">
    <div><dt>{language.t("cowork.enterprise.scope.entity")}</dt>
      <dd><A href={workspaceHref("/settings/setup")}>{props.company.name}</A></dd></div>
    <Show when={props.project}>{(project) => <div><dt>{language.t("cowork.enterprise.scope.project")}</dt>
      <dd><A href={workspaceHref(collectionPath("projects", { companyID: props.company.id }))}>{project().name}</A></dd></div>}</Show>
    <Show when={props.project && props.period}>{(period) => <div><dt>{language.t("cowork.enterprise.scope.period")}</dt>
      <dd><A href={workspaceHref(collectionPath("periods", { companyID: props.company.id, projectID: props.project!.id }))}>{formatDate(period().name)}</A></dd></div>}</Show>
  </dl>
}
